<template>
  <v-container grid-list-xl>
    <v-layout row wrap justify-center class="my-5">
      <v-flex xs12 sm4>
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div :class="ui.textHeadline">
              {{this.companyTitle2}}
            </div>
          </v-card-title>
          <v-card-text :class="ui.textDescription">
            {{this.companyDescription2}}
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm4 offset-sm1>
        <v-card class="elevation-0 transparent">
          <v-card-title primary-title class="layout justify-center">
            <div :class="ui.textHeadline">contact us</div>
          </v-card-title>
          <v-card-text :class="ui.textDescription">
            we are here to help. Please contact us if you require technical support or assistance with system configuration for your business.
          </v-card-text>
          <v-list class="transparent">
            <v-list-tile>
              <v-list-tile-action>
                <v-icon :class="ui.textBlue1">place</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="ui.textBlue1">
                  Brisbane, Australia
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon :class="ui.textBlue1">email</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title :class="ui.textBlue1">
                  {{this.companyEmail1}}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import apptheme from "@/frame/theme/mixins/apptheme.js";
import publicGlobals from "@/data/globals/mixins/publicGlobals.js";

export default { mixins: [apptheme, publicGlobals] };
</script>
